module.exports = "/_next/static/media/b09ed70c2615f86b416662cb57d7686c.svg";